<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="copy">
        <div>{{ expressname }}&nbsp;&nbsp;&nbsp;&nbsp;{{ expressno }}</div>
        <div @click="fuzi(expressno)">复制</div>
      </div>
      <div class="posi-over">
        <div class="item" v-for="(item, i) in expressArr" :key="i">
          <div class="item-time">
            <div class="item-time-title">{{ item.time.split(" ")[0] }}</div>
            <div class="item-time-content">{{ item.time.split(" ")[1] }}</div>
          </div>
          <div class="item-img">
            <img
              v-if="item.status == '签收'"
              src="@/assets/images/basicBusiness/q1.png"
              alt=""
            />
            <img
              v-if="item.status == '派件'"
              src="@/assets/images/basicBusiness/q2.png"
              alt=""
            />
            <img
              v-if="item.status == '在途'"
              src="@/assets/images/basicBusiness/q3.png"
              alt=""
            />
            <img
              v-if="item.status == '揽收'"
              src="@/assets/images/basicBusiness/q4.png"
              alt=""
            />
            <div></div>
          </div>
          <div class="item-info">
            <div v-if="item.status == '揽收'" class="item-info-title">
              揽收中
            </div>
            <div v-if="item.status == '在途'" class="item-info-title">
              运输中
            </div>
            <div v-if="item.status == '派件'" class="item-info-title">
              派件中
            </div>
            <div v-if="item.status == '签收'" class="item-info-title">
              已签收
            </div>
            <div class="item-info-content">
              {{ item.context }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
            <script>
export default {
  name: "FillIn",
  props: ["dataVal"],
  data() {
    return {
      expressname: "",
      expressno: "",
      expresscode: "",
      phone:"",
      expressArr: [],
      type:""
    };
  },
  mounted() {},
  methods: {
    async shopExpressinfo() {
      if (this.type == 1) {
        let res = await this.$api.shopRefundexpressinfo({
          expressno: this.expressno,
          expresscode: this.expresscode,
        });
        if (res.code == 1) {
          this.expressArr = res.data;
        }
        return false
      }
      let res = await this.$api.shopExpressinfo({
        expressno: this.expressno,
        expresscode: this.expresscode,
        phone:this.phone
      });
      if (res.code == 1) {
        this.expressArr = res.data;
      }else{
        this.expressArr = [];
      }
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("viewLogisticsCell", obj);
    },
    async fuzi(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$message({ message: "复制成功", type: "success" });
      } catch (err) {
        this.$message({ message: "复制失败", type: "error" });
      }
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        if (newVal.flag) {
          this.expressname = newVal.expressname;
          this.expressno = newVal.expressno;
          this.expresscode = newVal.expresscode;
          this.phone = newVal.phone||"";
          this.type = newVal.type||"";
          this.shopExpressinfo();
        }
      },
      deep: true,
    },
  },
};
</script>
            <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.posi-center {
  width: 845px;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  padding-bottom: 5vh;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 32px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  .copy {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000;
    font-size: 12px;
    border-bottom: 1px solid #ededed;
    height: 56px;
    padding: 0 30px 0 33px;
    div:first-child {
    }
    div:last-child {
      cursor: pointer;
    }
  }
  .posi-over {
    padding: 28px 32px;
    height: 454px;
    overflow-y: auto;
    .item {
      display: flex;
      .item-time {
        text-align: center;
        font-size: 12px;
        color: #979797;
        .item-time-title {
          margin-bottom: 3px;
        }
        .item-time-content {
        }
      }
      .item-img {
        margin: 0 9px;
        img {
          width: 20px;
          height: 20px;
        }
        div {
          width: 0.5px;
          min-height: 70px;
          background: #d9d9d9;
          margin-left: 10px;
        }
      }
      .item-info {
        .item-info-title {
          font-size: 14px;
          color: #000;
          margin-bottom: 8px;
        }
        .item-info-content {
          width: 600px;
          font-size: 12px;
          color: #333;
          min-height: 70px;
        }
      }
    }
    .item:last-child {
      .item-img {
        div {
          display: none;
        }
      }
    }
  }
  .posi-btn {
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #007aff;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>